import React from 'react';

const Hero = () => (
  <section className="bg-white dark:bg-gray-900">
    <div className="relative px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
      <div className="relative overflow-hidden rounded-3xl bg-secondary-100 dark:bg-secondary-900">
        <div className="relative px-6 py-12 sm:px-12 sm:py-16 lg:px-16 lg:py-20 xl:px-20">
          <div className="text-center">
            <p className="text-sm font-bold tracking-widest uppercase text-secondary-500 dark:text-secondary-400">
              Privacy Policy
            </p>
            <h1
              className="mt-6 text-3xl font-bold text-gray-900 dark:text-white sm:text-4xl lg:text-5xl sm:tracking-tight">
              We value your right to privacy
            </h1>
            <p className="max-w-3xl mx-auto mt-6 text-lg font-medium text-gray-500 dark:text-gray-200 lg:text-xl">
              We respect your privacy regarding any information we may collect
              from you across our website and
              applications.
            </p>
            <p className="mt-8 text-sm italic font-medium text-gray-500">
              Last updated: Nov, 2021
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Hero;
